import { render, staticRenderFns } from "./OtherClassesComponent.vue?vue&type=template&id=375008dc&scoped=true&"
import script from "./OtherClassesComponent.vue?vue&type=script&lang=js&"
export * from "./OtherClassesComponent.vue?vue&type=script&lang=js&"
import style0 from "./OtherClassesComponent.vue?vue&type=style&index=0&id=375008dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375008dc",
  null
  
)

export default component.exports